import { Loading } from '@shared-ui/components'
import { useGetUserQuery } from 'entities/users'
import { Suspense } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Outlet } from 'react-router-dom'
import { cn, useAppSelector } from 'shared/lib'
import { OfflineNotice } from 'shared/ui'
import { Header } from 'widgets/Header'
import { Sidebar } from 'widgets/Sidebar'
import { SidebarMenu } from 'widgets/SidebarMenu/SidebarMenu'
import { UserProfileMenuMobile } from 'widgets/UserProfileMenu/UserProfileMenuMobile'

export const MainLayout = () => {
    const isMenuOpen = useAppSelector(
        (state) => state?.globalReducer.isMenuOpen
    )
    const isUserProfileMobileMenuOpen = useAppSelector(
        (state) => state?.globalReducer.isUserProfileMobileMenuOpen
    )

    const isBigScreen = useMediaQuery({ query: '(min-width: 1023px)' })

    // Keep user data fresh for all authenticated pages
    useGetUserQuery('')

    return (
        <div className="fixed flex h-screen w-full flex-col overflow-x-hidden overflow-y-hidden bg-background-base">
            {/* Header */}
            <Header isMenuOpen={isMenuOpen} />

            {/* Body: sidebar + content */}
            <div className="flex flex-1 flex-row overflow-hidden">
                {/* Sidebar area. Below lg it takes no space: the drawer inside
                    is fixed and slides itself in and out, so this stays
                    mounted for its transition to play. On lg the rail's
                    width animates between expanded and collapsed. */}
                <div
                    className={cn(
                        'no-scrollbar h-full w-0 flex-shrink-0 lg:overflow-hidden lg:transition-[width] lg:duration-300 lg:ease-in-out lg:motion-reduce:transition-none',
                        isMenuOpen ? 'lg:w-[12.5rem]' : 'lg:w-[118px]'
                    )}
                >
                    <div className="h-full">
                        <Sidebar>
                            <SidebarMenu />
                        </Sidebar>
                    </div>
                </div>

                {/* Content area */}
                <div className="w-full min-w-0 overflow-x-hidden bg-work-in-progress p-2 pb-2 pt-2 sm:rounded-tl-3xl sm:p-3 sm:pt-3">
                    <OfflineNotice />
                    <Suspense fallback={<Loading />}>
                        <Outlet />
                    </Suspense>
                </div>

                {/* Mobile user profile menu */}
                {isUserProfileMobileMenuOpen && !isBigScreen && (
                    <UserProfileMenuMobile />
                )}
            </div>
        </div>
    )
}
